import axios from "axios";
import CryptoJS from "crypto-js";
import forge from "node-forge";

// lsq lapp names for different cases
const lappNames = {
  OTP: "da_46725_9f5d7299",
  CREATE: "da_46725_c0ebcc55",
  MAVIS: "da_46725_27857182",
};

// lsq base URL
const LSQ_BASE_URL =
  "https://f0jz2wbufc.execute-api.ap-south-1.amazonaws.com/default/lapp-proxy";

// call lsq api
export const callLSQLapp = async (payload, lappType, param) => {
  try {
    // console.log("payload, lappType, param", { payload, lappType, param });
    // create payload
    let proxyPayload = {
      method: "post",
      orgId: "46725",
      params: {
        stage: "Live",
        name: lappNames[lappType],
      },
      data: {
        lappBody: payload,
      },
    };

    // add params
    if (param) {
      const mergedObject = Object.assign({}, proxyPayload.params, param);
      proxyPayload.params = mergedObject;
    }
    const res = await axios.post(LSQ_BASE_URL, proxyPayload);
    return res;
  } catch (error) {
    console.log("callLSQLapp error", error);
  }
};

export function checkEligibility(data) {}

export function getLsqLeadBody(formData) {
  let Config = {
    utm_medium: "SourceMedium",
    utm_source: "mx_Source_UTM",
    ModeOfLead: "Source",
    pan: "mx_PAN",
    fullName: "FirstName",
    email: "EmailAddress",
    Branch: "mx_nearestBranchGL",
    mobile: "Mobile",
    companyName: "mx_Company_name",
    Occupation: "mx_Employment_Type",
    gclid: "mx_Gclid",
    Referral: "mx_Referral",
    Eligible: "mx_Eligible",
    Relationship: "mx_Relationship",
    utm_term: "mx_Utm_Terms",
    utm_lms: "mx_utm_lms",
    User_Agent: "mx_Lead_Device",
    IsAuthorized: "mx_Iauthorization",
    DND: "mx_DND_NDNC",
    CompleteUrl: "mx_UTM_URL_Details",
    utm_campaign: "SourceCampaign",
    utm_content: "SourceContent",
    Product: "mx_Product",
    Pincode: "mx_Pincode",
    token: "mx_Token",
    FBClickID: "mx_FB_Click_ID",
    FBPixelID: "mx_FB_Pixel_ID",
    isChecked: "mx_Iauthorization",
    CampaignId: "mx_Campaign_ID",
    dob: "mx_Date_of_Birth",
    annualIncome: "mx_Net_Salary",
    lastYearIncome: "mx_Gross_Salary",
    employmentType: "mx_Employment_Type",
    CardType: "mx_Product_Sub_Category",
    hasITR: "mx_Is_Income_Tax_Return_duly_acknowledged_by_Income_T",
    pageType: "mx_Dummy3",
    gbraid: "mx_GBRAID",
    wbraid: "mx_WBRAID",
    gad_source: "mx_test3",
    gad_campaignid: "mx_test4",
    utm_placement: "mx_UTM_Placement",
    utm_channel: "mx_UTM_Channel",
    utm_campaigntype: "mx_UTM_Campaigntype",
    utm_matchtype: "mx_UTM_Matchtype",
    utm_adgroup: "mx_Ad_Group",
    utm_aud:"mx_utm_aud",
    topCorporate: "mx_TopCorporatesEligibleFor",
    loanAmount: "mx_Loan_Amount",
  };
  let LeadBody = [];
  Object.keys(Config).forEach((key) => {
    if (formData.hasOwnProperty(key) && formData[key])
      LeadBody.push({
        Attribute: Config[key],
        Value: formData[key],
      });
  });
  return LeadBody;
}

export async function hashMobileNum(mobileNum) {
  if (mobileNum) {
    let formattedNum = await formatAndValidateE164(mobileNum);
    let hashedMobile = CryptoJS.SHA256(
      formattedNum.trim().toLowerCase()
    ).toString(CryptoJS.enc.Hex);
    await setValuesInLocalStorage(hashedMobile);
  } else {
    console.log("Mobile number is empty");
  }
}

async function setValuesInLocalStorage(mobile) {
  var data = {
    mobile,
  };
  // Convert the data to a JSON string
  var jsonData = JSON.stringify(data);
  // Store the JSON string in local storage
  localStorage.setItem("userData", jsonData);
}

async function formatAndValidateE164(phoneNumber) {
  // Fixed country code with '+'
  const countryCode = "91";

  // Remove all non-numeric characters except '+'
  let cleanedNumber = phoneNumber.replace(/[^\d+]/g, "");

  // Remove any leading '+' for now
  if (cleanedNumber.startsWith("+")) {
    cleanedNumber = cleanedNumber.substring(1);
  }

  // Ensure the number starts with country code '91'
  if (!cleanedNumber.startsWith(countryCode)) {
    cleanedNumber = countryCode + cleanedNumber;
  }

  // Add the `+` prefix back
  cleanedNumber = `+${cleanedNumber}`;
  console.log("cleanedNumber", cleanedNumber);
  // E.164 validation: 11 to 15 digits, including the '+' sign
  const e164Regex = /^\+?[1-9]\d{10,14}$/;
  if (e164Regex.test(cleanedNumber)) {
    return cleanedNumber; // Valid E.164 formatted number
  } else {
    return null; // Invalid format
  }
}

// Helper function to generate a random numeric string of a given length
const generateRandomNumber = (length) => {
  return Array.from({ length }, () => Math.floor(Math.random() * 10)).join("");
};

// AES encryption function using crypto-js
const encryptData = (value, sessionKey, iv) => {
  const encrypted = CryptoJS.AES.encrypt(
    value,
    CryptoJS.enc.Utf8.parse(sessionKey),
    {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return encrypted.toString();
};

// Main encryption function
export const encryptBody = async (payload) => {
  // Generate session key and IV
  const sessionKey = generateRandomNumber(16);
  const iv = generateRandomNumber(16);

  // Encrypt the session key with RSA using node-forge
  const publicKeyPem = process.env.REACT_APP_ICICI_PUBLIC_KEY;

  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
  const encryptedSessionKey = forge.util.encode64(
    publicKey.encrypt(sessionKey, "RSAES-PKCS1-V1_5")
  );

  // Prepare and encrypt the data payload
  const data = iv + JSON.stringify(payload);
  const encryptedData = encryptData(data, sessionKey, iv);

  // Construct the final encrypted response object
  return {
    requestId: "",
    service: "",
    encryptedKey: encryptedSessionKey,
    oaepHashingAlgorithm: "NONE",
    iv: "",
    encryptedData,
    clientInfo: "",
    optionalParam: "",
  };
};
